import AuthApi from "../../../services/api/authApi.js";
import { dialogHelper } from "@/components/mixin/dialogHelper";
import {sessionHelper} from "../../../components/mixin/sessionHelper";

const AuthApiService = new AuthApi();

export default {
  mixins: [dialogHelper, sessionHelper],
  data() {
    return {
      model: {
        email: "",
        password: "",
      },
      isZendeskSingleSignOn: false,
      brandUrlRedirect: null,
    };
  },

  methods: {
    focusEmailInput,
    signIn,
    postFirstLoginToAirtable,
    verifyNewEmail,
    checkParamsAndShowDialog,
  },

  // eslint-disable-next-line complexity
  beforeMount() {
    this.isZendeskSingleSignOn = this.$route.query.brand_id === this.$utils.constants.ZENDESK_ID;

    if (this.$route.query && this.$route.query.email_change_code) {
      this.$session.destroy();
      this.logout();
      this.verifyNewEmail();
    } else if (this.$session.getUserInfo() && !this.isZendeskSingleSignOn) {
      this.$router.push("/home");
    }
    this.checkParamsAndShowDialog();
  },

  mounted() {
    this.$eventBus.$on("focus-email-input", this.focusEmailInput);
  },

  beforeDestroy() {
    this.$eventBus.$off("focus-email-input", this.focusEmailInput);
  },
};

function focusEmailInput() {
  this.$refs.emailInput.focus();
}

function verifyNewEmail() {
  AuthApiService.verifyNewEmail({
    code: this.$route.query.email_change_code,
  }).catch((error) => {
    this.$swal("Attention", error.response.data.error_message);
  });
}

function signIn() {
  const request = {
    email: this.model.email,
    password: this.model.password,
  };

  this.$validator.validate().then((valid) => {
    if (!valid) {
      return;
    }

    AuthApiService.signIn(request)
      // eslint-disable-next-line complexity
      .then((response) => {
        this.$utils.handlePostLogin.call(this, response);
      })
      .catch((error) => {
        this.$ma.trackEvent({
          action: "Log In",
          properties: {
            Success: false,
            Error: error.response ? error.response.data.error_message : error,
          },
        });

        if (error.response) {
          this.$swal("Attention", error.response.data.error_message);
        } else {
          this.$logger.notify(new Error(error));
        }
      });
  });
}

function postFirstLoginToAirtable(email, date) {
  AuthApiService.sendFirstLoginAirtable({
    email: email,
    date: date,
  }).catch((error) => {
    this.$logger.notify(new Error(error));
  });
}

async function checkParamsAndShowDialog() {
  const { showSuspendedWarning } = this.$route.query;

  if (showSuspendedWarning) {
    await this.showMessageWarningToSuspendedOrDeclinedRetailers();
    this.$router.push("sign-in");
  }
}
